import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function CalculadoraPage() {
  const [contacts, setContacts] = useState(10);
  const [closeRate, setCloseRate] = useState(30);
  const [price, setPrice] = useState(350);
  const [recurring, setRecurring] = useState(false);
  const [bump, setBump] = useState(false);
  const closed = Math.round(contacts * (closeRate / 100));
  const sitesIncome = closed * price;
  const bumpIncome = bump ? closed * 17 : 0;
  const weeklyIncome = sitesIncome + bumpIncome;
  const monthlyIncome = weeklyIncome * 4;
  const recurringMonth = recurring ? closed * 4 * 99 : 0;
  const yearlyIncome = monthlyIncome * 12 + recurringMonth * 12;
  const fmt = (n: number) => {
    return '$' + Math.round(n).toLocaleString('en-US');
  };
  return <div className="min-h-screen bg-navy font-body text-white" data-id="element-842">
      {/* Header */}
      <header className="border-b border-gold/20 bg-navy-dark" data-id="element-843">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-844">
          <a href="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-845">
            <ArrowLeftIcon className="h-5 w-5" data-id="element-846" />
            <span className="font-body text-sm" data-id="element-847">Volver</span>
          </a>
          <h1 className="font-heading font-black text-xl md:text-2xl" data-id="element-848">
            <span className="text-gold" data-id="element-849">AI</span> Web Closer
          </h1>
          <div className="w-20" data-id="element-850" />
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-851">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-852">
          <h2 className="font-heading font-black text-3xl md:text-4xl mb-2" data-id="element-853">
            ¿Cuánto Puedes Ganar <span className="text-gold" data-id="element-854">Esta Semana?</span>
          </h2>
          <p className="font-body text-sm text-gray-400" data-id="element-855">
            Mueve los controles y calcula tu ingreso real con el sistema AI Web
            Closer
          </p>
        </motion.div>

        {/* Calculator Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 md:p-8 mb-6" data-id="element-856">
          <div className="font-heading font-bold text-xs tracking-widest text-gold uppercase mb-6" data-id="element-857">
            Calculadora de Ingresos
          </div>

          {/* Slider 1: Contacts */}
          <div className="mb-6" data-id="element-858">
            <div className="flex justify-between items-center mb-2" data-id="element-859">
              <span className="font-body text-sm text-gray-300" data-id="element-860">
                Negocios que contactas por semana
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[60px] text-center" data-id="element-861">
                {contacts}
              </div>
            </div>
            <input type="range" min="1" max="50" value={contacts} onChange={e => setContacts(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-862" />
          </div>

          {/* Slider 2: Close Rate */}
          <div className="mb-6" data-id="element-863">
            <div className="flex justify-between items-center mb-2" data-id="element-864">
              <span className="font-body text-sm text-gray-300" data-id="element-865">
                Tasa de cierre (% que dice SÍ)
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[60px] text-center" data-id="element-866">
                {closeRate}
                <span className="text-xs" data-id="element-867">%</span>
              </div>
            </div>
            <input type="range" min="5" max="60" value={closeRate} onChange={e => setCloseRate(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-868" />
          </div>

          {/* Slider 3: Price */}
          <div className="mb-8" data-id="element-869">
            <div className="flex justify-between items-center mb-2" data-id="element-870">
              <span className="font-body text-sm text-gray-300" data-id="element-871">
                Precio por sitio web
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[70px] text-center" data-id="element-872">
                ${price}
              </div>
            </div>
            <input type="range" min="150" max="1500" step="50" value={price} onChange={e => setPrice(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-873" />
          </div>

          {/* Divider */}
          <div className="relative mb-6" data-id="element-874">
            <div className="absolute inset-0 flex items-center" data-id="element-875">
              <div className="w-full border-t border-gold/20" data-id="element-876"></div>
            </div>
          </div>

          {/* Toggle: Recurring */}
          <div className="flex items-center gap-3 mb-4 p-3 bg-navy-light/50 rounded-lg border border-gold/10" data-id="element-877">
            <span className="font-body text-sm text-gray-300 flex-1" data-id="element-878">
              Añadir paquete de mantenimiento mensual ($99/cliente)
            </span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-879">
              <input type="checkbox" checked={recurring} onChange={e => setRecurring(e.target.checked)} className="sr-only peer" data-id="element-880" />
              <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gold" data-id="element-881"></div>
            </label>
            <div className="font-heading font-bold text-xs text-navy bg-gold rounded px-2 py-1" data-id="element-882">
              +$99/mes
            </div>
          </div>

          {/* Toggle: Bump */}
          <div className="flex items-center gap-3 mb-8 p-3 bg-navy-light/50 rounded-lg border border-gold/10" data-id="element-883">
            <span className="font-body text-sm text-gray-300 flex-1" data-id="element-884">
              Incluir upsell Kit del Primer Cliente ($17)
            </span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-885">
              <input type="checkbox" checked={bump} onChange={e => setBump(e.target.checked)} className="sr-only peer" data-id="element-886" />
              <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gold" data-id="element-887"></div>
            </label>
            <div className="font-heading font-bold text-xs text-navy bg-gold rounded px-2 py-1" data-id="element-888">
              +$17
            </div>
          </div>

          {/* Breakdown */}
          <div className="pt-2" data-id="element-889">
            <div className="font-heading text-xs font-bold tracking-widest text-gray-400 uppercase mb-4" data-id="element-890">
              Desglose Semanal
            </div>
            <div className="space-y-2" data-id="element-891">
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-892">
                <span className="font-body text-sm text-gray-400" data-id="element-893">
                  Negocios contactados
                </span>
                <span className="font-heading font-bold text-white" data-id="element-894">
                  {contacts}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-895">
                <span className="font-body text-sm text-gray-400" data-id="element-896">
                  Clientes cerrados
                </span>
                <span className="font-heading font-bold text-white" data-id="element-897">
                  {closed}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-898">
                <span className="font-body text-sm text-gray-400" data-id="element-899">
                  Ingreso por sitios web
                </span>
                <span className="font-heading font-bold text-gold" data-id="element-900">
                  {fmt(sitesIncome)}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-901">
                <span className="font-body text-sm text-gray-400" data-id="element-902">
                  Ingreso recurrente (mes 1)
                </span>
                <span className="font-heading font-bold text-gold" data-id="element-903">
                  {recurring ? `${fmt(closed * 99)}/sem` : '$0'}
                </span>
              </div>
              <div className="flex justify-between items-center py-3 border-t border-gold/20 mt-2" data-id="element-904">
                <span className="font-heading font-bold text-white" data-id="element-905">
                  Total semana 1
                </span>
                <span className="font-heading font-black text-xl text-gold" data-id="element-906">
                  {fmt(weeklyIncome)}
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Pricing Reference */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 md:p-8 mb-6" data-id="element-907">
          <div className="font-heading font-bold text-xs tracking-widest text-gold uppercase mb-6" data-id="element-908">
            💰 Precios de Referencia por Nicho
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-909">
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-910">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-911">
                🍕 Restaurantes
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-912">
                $300–$500
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-913">
                Alta urgencia
              </div>
            </div>
            <div className="bg-gold/10 border-2 border-gold rounded-lg p-4 text-center relative" data-id="element-914">
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold text-navy text-[10px] font-black px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-915">
                ⭐ RECOMENDADO
              </div>
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-916">
                🦷 Dentistas
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-917">
                $500–$900
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-918">
                Mayor ticket
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-919">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-920">
                🔧 Talleres
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-921">
                $250–$450
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-922">
                Fácil de cerrar
              </div>
            </div>
            <div className="bg-gold/10 border-2 border-gold rounded-lg p-4 text-center relative" data-id="element-923">
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold text-navy text-[10px] font-black px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-924">
                ⭐ RECOMENDADO
              </div>
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-925">
                ⚖️ Abogados
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-926">
                $700–$1,500
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-927">
                Máximo ticket
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-928">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-929">
                ✂️ Peluquerías
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-930">
                $200–$350
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-931">
                Volumen alto
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-932">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-933">
                🏋️ Gimnasios
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-934">
                $350–$600
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-935">
                Buen margen
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}